import { Rate, Form } from 'antd';
import React from 'react';
import { Controller, UseControllerProps } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Block } from '../../layouts';
import { TextProps } from '../../typo';
import { FormConnector } from '../FormConnector';

interface RateFieldProps {
    name: string;
    label?: string;
    rules?: UseControllerProps['rules'];
    labelStyle?: TextProps;
    description?: string;
    allowHalf?: boolean;
    disabled?: boolean;
}

export const RateField = (props: RateFieldProps) => {
    const { t } = useTranslation();
    const { name, rules, allowHalf, disabled } = props;

    return (
        <FormConnector>
            {(form) => {
                const { control } = form;

                return (
                    <Block width='100%'>
                        <Controller
                            name={name}
                            control={control}
                            rules={rules}
                            render={({ field, fieldState }) => (
                                <Form.Item
                                    validateStatus={fieldState.error ? 'error' : undefined}
                                    help={fieldState.error?.message ? t(fieldState.error?.message) : undefined}
                                >
                                    <Rate
                                        allowHalf={allowHalf}
                                        disabled={disabled}
                                        value={field.value || 0} // 🔥 Fix: Đảm bảo không bị undefined
                                        onChange={(newValue) => field.onChange(newValue)} // 🔥 Fix: Chỉ dùng field.onChange
                                        style={{
                                            color: '#ff9800',
                                            fontSize: 31,
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                        }}
                                    />
                                </Form.Item>
                            )}
                        />
                    </Block>
                );
            }}
        </FormConnector>
    );
};

RateField.defaultProps = {
    allowHalf: true,
    disabled: false,
};
